import { Paper, Typography, styled } from "@mui/material";

// Palette from the Tax Center PRD mockups (Caleb & Brown design system tokens).
export const NAVY = "#002035";
export const SALMON = "#fc4c4c";
export const TEXT_SECONDARY = "#545454";
export const TEXT_MUTED = "#8A9AA4";
export const BORDER = "#E5E9EB";
export const BORDER_LIGHT = "#F0F3F4";
export const TEAL = "#01C0AA";
const TEAL_DARK = "#01A08E";
const TEAL_BG = "#E6F9F6";
export const AMBER = "#E9950C";
const AMBER_TEXT = "#B26B00";
const AMBER_BG = "#FFF4E5";
const RED = "#cc0000";
const RED_BG = "#FDE9E9";

export const Eyebrow = styled(Typography)({
  textTransform: "uppercase",
  letterSpacing: 1.4,
  fontSize: 11,
  fontWeight: 600,
});

export const Card = styled(Paper)({
  borderRadius: 8,
  border: `1px solid ${BORDER}`,
  overflow: "hidden",
  boxShadow: "none",
});

export type PillTone = "warning" | "success" | "error" | "neutral";

const PILL_TONES: Record<PillTone, { background: string; color: string; dot?: string }> = {
  warning: { background: AMBER_BG, color: AMBER_TEXT, dot: AMBER },
  success: { background: TEAL_BG, color: TEAL_DARK, dot: TEAL },
  error: { background: RED_BG, color: RED },
  neutral: { background: BORDER_LIGHT, color: TEXT_SECONDARY },
};

export const StatusPill = styled("span", {
  shouldForwardProp: (prop) => prop !== "tone",
})<{ tone: PillTone }>(({ tone }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "6px 10px",
  borderRadius: 12,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1,
  whiteSpace: "nowrap",
  backgroundColor: PILL_TONES[tone].background,
  color: PILL_TONES[tone].color,
  ...(PILL_TONES[tone].dot && {
    "&::before": {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: "50%",
      backgroundColor: PILL_TONES[tone].dot,
    },
  }),
}));

export const CountPill = styled("span", {
  shouldForwardProp: (prop) => prop !== "tone",
})<{ tone: "error" | "neutral" }>(({ tone }) => ({
  padding: "4px 7px",
  borderRadius: 9,
  fontSize: 11,
  fontWeight: 600,
  lineHeight: 1,
  backgroundColor: tone === "error" ? RED_BG : BORDER_LIGHT,
  color: tone === "error" ? RED : TEXT_SECONDARY,
}));
